export const FETCH_DASHBOARD_SUMMARY_REQUEST = "FETCH_DASHBOARD_SUMMARY_REQUEST";
export const FETCH_DASHBOARD_SUMMARY_SUCCESS = "FETCH_DASHBOARD_SUMMARY_SUCCESS";
export const FETCH_DASHBOARD_SUMMARY_FAILURE = "FETCH_DASHBOARD_SUMMARY_FAILURE";